import styled, { css } from 'styled-components';
import { theme, palette } from 'styled-tools';

const commonPadding = css`padding: 16px 0;`;

export const CaptionWrapper = styled.div`
    ${commonPadding}
    text-align: start;
    ${theme('fontStyle.body2')}
    color: ${palette('gray_opacity_600')};
`;

export const BtnInterviewWrapper = styled.div`
    ${commonPadding}
    text-align: left;
    > button:not(:first-child) { margin-top: 12px;}
`;

export const BtnContentsContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
`;

export const BtnContentsWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    > svg {
        margin-right: 12px;
    }
`;